<template>
  <div>
    <v-text-field label="AppID" hint="支付宝AppId" class="required" v-model="value.app_id" />
    <v-select
      right
      label="鉴权方式"
      class="required"
      hint="支付宝接口加签与验签方式"
      v-model="value.auth_type"
      :items="authTypeItems"
    />
    <v-select
      right
      label="签名类型"
      class="required"
      hint="支付宝开放平台-应用信息中查看"
      v-model="value.sign_type"
      :items="['RSA', 'RSA2']"
    />
    <v-textarea
      class="config-textarea required"
      hint="支付宝开放平台-应用信息中查看"
      v-model="value.app_private_key"
      label="应用私钥文件内容(非Java语言格式)"
    />
    <template v-if="value.auth_type === 'K'">
      <v-textarea
        class="config-textarea required"
        hint="支付宝开放平台-应用信息中查看"
        v-model="value.alipay_public_key"
        label="支付宝公钥文件内容"
      />
    </template>
    <template v-if="value.auth_type === 'C'">
      <v-textarea
        class="config-textarea required"
        hint="支付宝开放平台-应用信息中查看"
        v-model="value.app_public_key_cert"
        label="应用公钥证书文件内容"
      />
      <v-textarea
        class="config-textarea required"
        hint="支付宝开放平台-应用信息中查看"
        v-model="value.alipay_public_key_cert"
        label="支付宝公钥证书文件内容"
      />
      <v-textarea
        class="config-textarea required"
        hint="支付宝开放平台-应用信息中查看"
        v-model="value.alipay_root_cert"
        label="支付宝根证书文件内容"
      />
    </template>
    <v-checkbox label="支持电脑网站支付" v-model="value.is_support_pc" />
    <v-checkbox label="支持手机网站支付" v-model="value.is_support_h5" />
    <v-checkbox label="支持APP支付" v-model="value.is_support_app" />
    <v-checkbox label="支持当面付(扫码支付)" v-model="value.is_support_code" />
    <v-checkbox label="是否沙箱环境" v-model="value.is_sandbox" />
  </div>
</template>

<script>
export default {
  components: {},
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    const authTypeItems = [
      {
        text: '公钥方式',
        value: 'K',
      },
      {
        text: '证书方式',
        value: 'C',
      },
    ]
    return {
      authTypeItems: authTypeItems,
    }
  },
}
</script>

<style lang="less" scoped>
.config-textarea /deep/ textarea {
  font-size: 14px;
  font-family: monospace;
  white-space: pre-wrap;
  line-height: 1.5;
}
</style>
